import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CONTROLLERS, ENDPOINTS } from '../constants';
import { GetSubscriptionListReq, Response, SubscriptionList } from '../models';
import { ApiService } from './api.service';
import { ActiveSubscriptionReq } from '../models/subscribed-subscription.model';

@Injectable({
  providedIn: 'root',
})
export class SubscriptionService {
  private api: string = CONTROLLERS.SUBSCRIPTION;
  constructor(private apiService: ApiService) {}

  getSubscriptionList(
    paginationRequestCommand: GetSubscriptionListReq
  ): Observable<Response<SubscriptionList>> {
    return this.apiService.post(
      `${this.api}/${ENDPOINTS.SUBSCRIPTION.GET_MEMBER_SUBSCRIPTION_LIST}`,
      paginationRequestCommand
    );
  }

  getSubscribedSubscriptionList(
    paginationRequestCommand: GetSubscriptionListReq
  ): Observable<Response<any>> {
    return this.apiService.post(
      `${this.api}/${ENDPOINTS.SUBSCRIPTION.GET_SUBSCRIBED_SUBSCRIPTION_LIST}`,
      paginationRequestCommand
    );
  }


  getSubscribedSubscriptionListByPractice(
    practiceId: number
  ): Observable<Response<any>> {
    return this.apiService.post(
      `${this.api}/${ENDPOINTS.SUBSCRIPTION.GET_SUBSCRIBED_SUBSCRIPTION_LIST_BY_PRACTICE_ID}`,
      {practiceId: practiceId}
    );
  }
  activeSubscription(data: ActiveSubscriptionReq): Observable<Response<any>> {
    return this.apiService.put(
      "",  
      `${this.api}/${ENDPOINTS.SUBSCRIPTION.ACTIVATE_DEACTIVE_SUBSCRIPTION}`,
      data
    );
  }
    getSubscriptionById(id: number) {
    return this.apiService.get(
      `${this.api}/${ENDPOINTS.SUBSCRIPTION.GET_SUBSCRIBED_SUBSCRIPTION_BY_ID}/${id}`
    );
  }
  getShowCommunicationLimitById(id:number){
     return this.apiService.get(
      `${this.api}/${ENDPOINTS.SUBSCRIPTION.SHOW_COMMINICATION_BY_ID}/${id}`
    );
  }
}
